"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Menu_Item_1 = __importDefault(require("./Menu.Item"));
var Menu_Section_1 = __importDefault(require("./Menu.Section"));
var __1 = require("..");
require("./Menu.css");
var BaseMenu_1 = __importDefault(require("./BaseMenu"));
function Menu(_a) {
    var children = _a.children, title = _a.title, href = _a.href, footer = _a.footer, onClose = _a.onClose, _b = _a.show, show = _b === void 0 ? false : _b, _c = _a.position, position = _c === void 0 ? "right" : _c;
    var handleClickOutside = function (event) {
        if (event.target.id === "nimbus--menu") {
            onClose();
        }
    };
    var wrapperClassName = (0, classnames_1.default)("nimbus--menu", { "is--visible": show }, "position--".concat(position));
    return (React.createElement(__1.Portal, { show: show },
        React.createElement("div", { id: "nimbus--menu", className: wrapperClassName, role: "presentation", onClick: handleClickOutside },
            React.createElement("div", { className: "nimbus--menu-wrapper" },
                React.createElement(BaseMenu_1.default, { title: title, href: href, footer: footer }, children)))));
}
Menu.Section = Menu_Section_1.default;
Menu.Item = Menu_Item_1.default;
exports.default = Menu;
//# sourceMappingURL=Menu.js.map